module.exports = __webpack_public_path__ + "product-compound-capsule-04.jpg?7027c7a24c770f0e6e675cc2c2cb2b51";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-04.jpg
// module id = 101
// module chunks = 0